<template>
    <div v-if="isVisible" class="countdown-container">
        {{ counterDownTime }}
    </div>
</template>
<script>
export default {
    name: 'CounterdownCompo',
    props: {
        isVisible: {
            type: Boolean,
            default: true
        },
        showDays: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            //weeklyFormatTime: ''
            counterDownTime: ''
        }
    },
    methods: {
        updateCountdown() {
            var now = new Date();
            var end = new Date();
            end.setHours(23, 59, 59);  // Set end time to 11:59:59 PM
            // end.setDate(end.getDate() + (7 - now.getDay()));  // Set end date to next Sunday

            if (now.getDay() === 0) { // Check if today is Sunday
                end.setDate(end.getDate()); // This doesn't change anything; consider revising logic here
            } else {
                end.setDate(end.getDate() + (7 - now.getDay())); // Different adjustment for dates on/after 2025-01-01
            }

            var timeDifference = end - now;
            if (timeDifference <= 0) {
                this.counterDownTime = "Countdown expired";
                return;
            }
            const { days, hours, minutes, seconds } = this.calculateTimeDifference(timeDifference);
            this.counterDownTime = this.formatTime(days, hours, minutes, seconds);
        },
        calculateTimeDifference(timeDifference) {
            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
            return { days, hours, minutes, seconds };
        },
        formatTime(days, hours, minutes, seconds) {
            // Pad to two digits so the countdown keeps a steady width instead of
            // jumping as it ticks past 10 (e.g. "5D: 06: 14: 19", not "5D: 6: 14: 19").
            const pad = (value) => String(value).padStart(2, '0');

            let formattedTime = '';
            if (this.showDays) {
                formattedTime += `${days}D: `;
            }
            formattedTime += `${pad(hours)}: ${pad(minutes)}: ${pad(seconds)}`;
            return formattedTime;
        }
    },
    created() {
        this.updateCountdown();
        setInterval(this.updateCountdown, 1000);
    }
}
</script>